module.exports = __webpack_public_path__ + "static/media/66.9cac60d0.svg";